import React from 'react';
import { Link } from 'react-router-dom';

const features = [
  { garage: 'Reduce no-shows with automated reminders', customer: 'Book appointments online 24/7' },
  { garage: 'Instantly view vehicle history',             customer: 'Automatic MOT & service reminders' },
  { garage: 'Effortless quoting & invoicing',             customer: 'Clear quotes and easy communication' },
];

const Features: React.FC = () => (
  <section className="container section">
    <h2>Benefits for you & your customers</h2>
    <div className="features-grid" style={{ marginTop: '2rem' }}>
      {features.map((f, i) => (
        <div key={i} className="feature-card">
          <h3 style={{ color: 'var(--primary)' }}>Garage</h3>
          <p>{f.garage}</p>
          <hr style={{ margin: '1rem 0' }} />
          <h3 style={{ color: 'var(--primary-light)' }}>Customer</h3>
          <p>{f.customer}</p>
        </div>
      ))}
    </div>
    <div className="section-cta">
      <Link to="/get-started" className="cta">Get started for free</Link>
    </div>
  </section>
);

export default Features;
